<template>
  <ValidationObserver ref="newGroup">
    <Dialog :data="dialogSettings">
      <ValidationProvider v-slot="{ errors }" name="section" rules="required">
        <Select
          :value="selectedSection"
          @input="onSelect"
          v-model="selectedSection"
          label="Select"
          :loading="isFetchingOfferGroupTemplates"
          placeholder="Select Section"
          :items="offerGroupTemplates"
          item-text="name"
          item-value="id"
          :error-messages="showValidationErrors ? errors : ''"
          return-object
        />
      </ValidationProvider>
      <div
        v-for="(groupDocument, index) in documents"
        :key="index"
        class="ma-2"
      >
        {{ groupDocument.name }}
        <div class="mt-2">
          <FileComponent
            class="pb-2"
            v-for="file in [
              groupDocument.sourceDocument,
              groupDocument.responseDocument
            ].filter(Boolean)"
            :key="file.id"
            :file="file"
            @show="showFile(file)"
            customActions
            disabled
            showFileName
          />
        </div>
      </div>
      <PDFViewFull :data="fileDialog" />
      <template v-slot:dialog.actions>
        <PrimaryButton @click.native="close" text>Cancel</PrimaryButton>
        <PrimaryButton @click.native="onSubmit" :loading="isAddingOfferGroup">
          Create Section
        </PrimaryButton>
      </template>
    </Dialog>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import Dialog from "@/components/common/Dialog";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { getFilePreviewSettings } from "@/utils/files";
import PDFViewFull from "@/components/common/PDFViewFull";
import FileComponent from "@/components/common/FileComponent";
import Select from "@/components/common/Select";
import {
  FETCH_OFFER_GROUP_TEMPLATES,
  ADD_OFFER_GROUP
} from "@/store/modules/offers/actions";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "AddOfferGroupDialog",
  components: {
    Dialog,
    PrimaryButton,
    ValidationObserver,
    ValidationProvider,
    PDFViewFull,
    FileComponent,
    Select
  },
  created() {
    this.fetchOfferGroupTemplates();
  },
  data() {
    return {
      documents: [],
      selectedSection: null,
      showValidationErrors: false,
      dialogSettings: {
        dialog: true,
        title: "Add section"
      },
      fileDialog: { dialog: false }
    };
  },
  computed: {
    ...mapState([
      "isFetchingOfferGroupTemplates",
      "offerGroupTemplates",
      "isAddingOfferGroup"
    ]),
    currentOfferId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      fetchOfferGroupTemplates: FETCH_OFFER_GROUP_TEMPLATES,
      addOfferGroup: ADD_OFFER_GROUP
    }),
    onSelect(groupTemplate) {
      this.selectedSection = groupTemplate.id;
      this.documents = groupTemplate.documents;
    },
    close() {
      this.$emit("close");
    },
    async showFile(file) {
      const filePreviewSettings = await getFilePreviewSettings(file);
      this.fileDialog = {
        ...filePreviewSettings,
        dialog: true
      };
    },
    async onSubmit() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.newGroup.validate();
      if (isValid) {
        await this.addOfferGroup({
          offerId: this.currentOfferId,
          templateId: this.selectedSection
        });
        this.close();
      }
    }
  }
};
</script>

<style></style>
